var map = {
	"./banner-congrats.svg": 9727,
	"./board.svg": 156,
	"./captions.svg": 7964,
	"./checkmark.svg": 717,
	"./disable_animations.svg": 3527,
	"./disable_captions.svg": 626,
	"./enable_animations.svg": 7161,
	"./enable_captions.svg": 1957,
	"./goodbye.svg": 8417,
	"./hourglass.svg": 9115,
	"./inactive-moon.svg": 9058,
	"./left_trophy.svg": 2398,
	"./more.svg": 9728,
	"./mr_c_ok.svg": 6546,
	"./new-trophy.svg": 4999,
	"./practice_intro.svg": 8200,
	"./practice_results.svg": 324,
	"./quiz_intro.svg": 2266,
	"./quiz_results.svg": 5585,
	"./red-x.svg": 2800,
	"./right_trophy.svg": 4225,
	"./smiley.svg": 6727,
	"./speech-bubble-above.svg": 4271,
	"./student_frame.svg": 4128,
	"./student_info.svg": 6087,
	"./thumbs_up.svg": 8437,
	"./trophy-arrow.svg": 9384,
	"./trophy_background.svg": 261,
	"./trophy_frame.svg": 4187,
	"./welcome.svg": 3007
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3791;